import React, { useLayoutEffect } from 'react';

const ScalableElement = (props) => {
	if (!props.element) {
		return;
	}

	const element = props.element;
	const style = `#txtbtntxtbutton-${props.index}{${element.font?.value}}
                #somebtnbutton-${props.index} {fill:${element.color?.value};}
                #somebtnbutton-${props.index}:not(.mobile-element):hover{fill:${element.hovercolor?.value};stroke:${element.hovercolor?.value};stroke-width:5px;}
                #btnGrpbutton-${props.index}{transform: translate(${element?.x?.value}px, ${element?.y?.value}px)}`;

	useLayoutEffect(() => {
		props.onEnter?.();
	}, []);

	return (
		<>
			<g id={`btnGrpbutton-${props.index}`} data-name="Layer 1">
				<rect
					id={`somebtnbutton-${props.index}`}
					className={props.isMobile ? 'mobile-element' : undefined}
					gid={element?.grid?.value || 'button'}
					x="0"
					y="0"
					width={props.element?.width?.value}
					height={props.element?.height?.value}
					rx={props.element?.radius?.value}
					onClick={props.onClick}
					onTouchStart={props.onClick}
				></rect>
				<text
					id={`txtbtntxtbutton-${props.index}`}
					x={props.element?.width?.value ? props.element?.width?.value / 2 : 0}
					y={props.element?.height?.value ? props.element?.height?.value / 2 : 0}
					textAnchor="middle"
					dominantBaseline="central"
					pointerEvents="none"
				>
					{props.element?.text?.value ?? 'Button'}
				</text>
			</g>
			<defs>
				<style>{style}</style>
			</defs>
		</>
	);
};

export default ScalableElement;
